export enum AuthMutationTypes {
  Login = '[Auth] Login',
  LoginSuccess = '[Auth] LoginSuccess',
  LoginFailure = '[Auth] LoginFailure',
  Logout = '[Auth] Logout',
  LogoutSuccess = '[Auth] LogoutSuccess',
  LogoutFailure = '[Auth] LogoutFailure',
  ForgotPassword = '[Auth] ForgotPassword',
  ResetPassword = '[Auth] ResetPassword',
  ForgotPasswordSuccess = '[Auth] ForgotPasswordSuccess',
  ForgotPasswordFailure = '[Auth] ForgotPasswordFailure',
  ResetPasswordSuccess = '[Auth] ResetPasswordSuccess',
  ResetPasswordFailure = '[Auth] ResetPasswordFailure',
  Registration = '[Auth] Registration',
  RegistrationSuccess = '[Auth] RegistrationSuccess',
  RegistrationFailure = '[Auth] RegistrationFailure',
}
